import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { Invitation } from "@models/invitation";
import { InvitationRequest } from "@models/invitationRequest";
import { PatientUser } from "@models/patient-user";
import { accountSetupApi } from "@store/accountSetupApi";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const invitationApi = createApi({
  reducerPath: "invitationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/invitations`,
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    createInvitation: builder.mutation<Invitation, InvitationRequest>({
      query: (invitation: InvitationRequest) => {
        return {
          url: "invite",
          method: "POST",
          body: invitation,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(accountSetupApi.util.invalidateTags(["AccountSetupProgress"]));
      },
    }),
    getInvitation: builder.query<Invitation, { patientId: string }>({
      query: (params) => {
        return {
          url: "invite",
          method: "GET",
          params,
        };
      },
    }),
    redeemInvitation: builder.mutation<
      { accessToken: string; user: PatientUser },
      { checkString: string; code: string; deviceId: string }
    >({
      query: (body) => {
        return {
          url: "redeem",
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const {
  useCreateInvitationMutation,
  useGetInvitationQuery,
  useRedeemInvitationMutation,
} = invitationApi;
